import { gql, useApolloClient } from "@apollo/client";
import { useAsyncExecutor } from "async-executor-hook";
import { format, parse } from "date-fns";

import { ProcessingModal } from "../../common/components/ProcessingModal";
import DownArrow from "../../images/down_arrow.svg";
import IconPdf from "../../images/image_pdf.svg";
import IconXlsx from "../../images/image_xlsx.svg";
import { NUMBER_OF_SUBTRACTED_DAYS } from "../../utils/complaintsConstants";
import { GRAPHQL_METHODS } from "../../utils/constants";
import { subtractDaysToDate } from "../../utils/dates";
import { networkGraphqlRequest } from "../../utils/networkUtils";
import {
  ContainerModal,
  MainButtonReclamos,
} from "../AdminComplaintsDetailSidebar/AdminComplaintsDetailSidebar";
import Modal from "../Modal/Modal";

export const DownloadReportModal = (props) => {
  const { params } = props;
  const client = useApolloClient();

  const GET_PDF = gql`
    query ($q: PaginationQuery!) {
      getAdminReportsToPDF(query: $q)
    }
  `;

  const GET_EXCEL = gql`
    query ($q: PaginationQuery!) {
      getAdminReportsToExcel(query: $q)
    }
  `;

  const downloadFile = useAsyncExecutor(
    async (params: any) => {
      const date = params.data.date
        ? params.data.date
        : subtractDaysToDate(new Date(), NUMBER_OF_SUBTRACTED_DAYS);

      const parsedDate =
        typeof date === "string" ? parse(date, "dd-MM-yyyy", new Date()) : date;

      const formatedDate = format(parsedDate, "yyyy-MM-dd");
      const query = params.type === "pdf" ? GET_PDF : GET_EXCEL;
      const caseNumber = params.caseNumber ? params.caseNumber : "";
      const dateValid = params.data.enterDate
        ? params.data.enterDate
        : formatedDate;
      const area = params.data.area ? params.data.area : "";
      const category = params.data.category ? params.data.category : "";
      const clientName = params.data.clientName ? params.data.clientName : "";

      const paramsGraphql = {
        q: {
          caseNumber,
          date: dateValid,
          area,
          category,
          clientName,
        },
      };
      const resp = await networkGraphqlRequest(
        GRAPHQL_METHODS.QUERY,
        client,
        query,
        paramsGraphql
      );
      return resp[
        `getAdminReportsTo${params.type === "pdf" ? "PDF" : "Excel"}`
      ];
    },
    {
      onSuccess: (pdfUrl) => {
        window.open(pdfUrl);
      },
    }
  );
  return (
    <Modal onOutsideClick={() => props.handleClose()}>
      <ProcessingModal status={[downloadFile.status]}></ProcessingModal>
      <ContainerModal>
        <div>
          <div className="select-format-download">
            <b>Seleccione los formatos a descargar</b>
          </div>
          <div
            className="content-detail"
            style={{ cursor: "pointer" }}
            onClick={() => {
              downloadFile.execute({ data: params, type: "pdf" });
            }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: 15 }}>
                <img src={IconPdf} alt="pdf" />
              </div>
              <div className="detail-file">Lista de quejas.pdf</div>
            </div>
            <div style={{ width: 30 }}>
              <div style={{ left: 0 }}>
                <img src={DownArrow} alt="downArrow" />
              </div>
            </div>
          </div>
          <div
            className="content-detail"
            style={{ cursor: "pointer" }}
            onClick={() => {
              downloadFile.execute({ data: params, type: "excel" });
            }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: 15 }}>
                <img src={IconXlsx} alt="Icon" style={{ cursor: "pointer" }} />
              </div>
              <div className="detail-file">Lista de quejas.xlsx</div>
            </div>
            <div style={{ width: 30 }}>
              <div style={{ left: 0 }}>
                <img
                  src={DownArrow}
                  alt="DdwnArrow"
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
        </div>
        <MainButtonReclamos
          onClick={() => {
            props.handleClose();
          }}
        >
          Listo
        </MainButtonReclamos>
      </ContainerModal>
    </Modal>
  );
};
